import { DEFAULT_LOCALE, normalizeLocale } from '@skillarea/lib-shared';

import privacyKa from './privacy.ka.md?raw';
import privacyEn from './privacy.md?raw';
import termsKa from './terms.ka.md?raw';
import termsEn from './terms.md?raw';

function resolveLegalLocale(language: string): string {
  return normalizeLocale(language) ?? DEFAULT_LOCALE;
}

export function resolveTermsContent(language: string): string {
  return resolveLegalLocale(language) === 'ka' ? termsKa : termsEn;
}

export function resolvePrivacyContent(language: string): string {
  return resolveLegalLocale(language) === 'ka' ? privacyKa : privacyEn;
}
